import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { queryClient } from 'src/core/react-query';
import { WebinarDetails } from 'src/core/types';

import axios from './axios';

export interface UseMutateWebinarInfoVariables {
  description: string | null;
  language?: string;
  duration: string;
  invitations: {
    invited: number;
    is_admin: boolean;
  }[];
  is_recurring: boolean;
  schedule?: {
    count: number;
    end_date: string | null;
    frequency: number;
    limit_type: 'count' | 'date';
    month_recurrence_type: 'day' | 'week';
    recurring_month_day: number | null;
    recurring_month_week: number | null;
    recurring_weekday: number | null;
    recurring_weekdays: string;
    start_date: string;
    start_time: string;
    type: 'daily' | 'weekly' | 'monthly';
  };
  start_datetime: string | null;
  title: string;
}

export interface UseMutateWebinarInfoData extends WebinarDetails {}

export function useMutateWebinarInfo(id?: number) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseMutateWebinarInfoData,
    AxiosError<UseMutateWebinarInfoData>,
    UseMutateWebinarInfoVariables
  >(
    (variables) => {
      const data = { ...variables, is_private: true };

      if (id) {
        return axios
          .put<UseMutateWebinarInfoData>(`/posht/yashar/webinars/${id}/`, data)
          .then((res) => res.data);
      }

      return axios
        .post<UseMutateWebinarInfoData>('/posht/yashar/webinars/', data)
        .then((res) => res.data);
    },
    {
      onError: () => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
      onSettled: () => {
        queryClient.invalidateQueries(['webinar', id?.toString()]);
      },
      onSuccess: () => {
        enqueueSnackbar(t('operation.successful'), { variant: 'success' });
      },
    },
  );
}
